const banks = [
  {
    id: 1,
    name: 'Union Bank',
    accountNumber: '0099112233',
    accountName: 'Test Bank1'
  },
  {
    id: 2,
    name: 'Union Bank',
    accountNumber: '0099112233',
    accountName: 'Test Bank1'
  },
  {
    id: 3,
    name: 'Union Bank',
    accountNumber: '0099112233',
    accountName: 'Test Bank1'
  },
  {
    id: 4,
    name: 'Union Bank',
    accountNumber: '0099112233',
    accountName: 'Test Bank1'
  },
  {
    id: 18,
    name: 'Union Bank',
    accountNumber: '0099112233',
    accountName: 'Test Bank1'
  },
  {
    id: 28,
    name: 'Union Bank',
    accountNumber: '0099112233',
    accountName: 'Test Bank1'
  },
  {
    id: 38,
    name: 'Union Bank',
    accountNumber: '0099112233',
    accountName: 'Test Bank1'
  },
  {
    id: 48,
    name: 'Union Bank',
    accountNumber: '0099112233',
    accountName: 'Test Bank1'
  }
]

const AllBanks = () => {
  return (
    <div className="bank-list">
      {
        banks.map((bank) => (
          <BankCard bank={bank} key={bank.id} />
        ))
      }
    </div>
  );
};

export default AllBanks;


const BankCard = ({bank}) => {
  return (
    <div className="bank-card">
      <div className="top">
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M21.3125 17.875C21.3125 18.0573 21.2401 18.2322 21.1111 18.3611C20.9822 18.4901 20.8073 18.5625 20.625 18.5625H1.375C1.19266 18.5625 1.0178 18.4901 0.888864 18.3611C0.759933 18.2322 0.6875 18.0573 0.6875 17.875C0.6875 17.6927 0.759933 17.5178 0.888864 17.3889C1.0178 17.2599 1.19266 17.1875 1.375 17.1875H20.625C20.8073 17.1875 20.9822 17.2599 21.1111 17.3889C21.2401 17.5178 21.3125 17.6927 21.3125 17.875ZM1.40078 8.43735C1.35989 8.29317 1.36723 8.13958 1.42168 7.99996C1.47613 7.86034 1.57472 7.74234 1.70242 7.66391L10.6399 2.16391C10.7482 2.09732 10.8729 2.06207 11 2.06207C11.1271 2.06207 11.2518 2.09732 11.3601 2.16391L20.2976 7.66391C20.4253 7.74224 20.524 7.86016 20.5785 7.99972C20.6331 8.13929 20.6405 8.29285 20.5998 8.43705C20.559 8.58124 20.4722 8.70817 20.3527 8.79851C20.2331 8.88885 20.0873 8.93766 19.9375 8.9375H17.875V14.4375H19.25C19.4323 14.4375 19.6072 14.5099 19.7361 14.6389C19.8651 14.7678 19.9375 14.9427 19.9375 15.125C19.9375 15.3073 19.8651 15.4822 19.7361 15.6111C19.6072 15.7401 19.4323 15.8125 19.25 15.8125H2.75C2.56766 15.8125 2.3928 15.7401 2.26386 15.6111C2.13493 15.4822 2.0625 15.3073 2.0625 15.125C2.0625 14.9427 2.13493 14.7678 2.26386 14.6389C2.3928 14.5099 2.56766 14.4375 2.75 14.4375H4.125V8.9375H2.0625C1.91279 8.93756 1.76715 8.88874 1.64771 8.79846C1.52828 8.70819 1.44158 8.5814 1.40078 8.43735ZM12.375 13.75C12.375 13.9323 12.4474 14.1072 12.5764 14.2361C12.7053 14.3651 12.8802 14.4375 13.0625 14.4375C13.2448 14.4375 13.4197 14.3651 13.5486 14.2361C13.6776 14.1072 13.75 13.9323 13.75 13.75V9.625C13.75 9.44267 13.6776 9.2678 13.5486 9.13887C13.4197 9.00994 13.2448 8.9375 13.0625 8.9375C12.8802 8.9375 12.7053 9.00994 12.5764 9.13887C12.4474 9.2678 12.375 9.44267 12.375 9.625V13.75ZM8.25 13.75C8.25 13.9323 8.32243 14.1072 8.45136 14.2361C8.5803 14.3651 8.75516 14.4375 8.9375 14.4375C9.11984 14.4375 9.2947 14.3651 9.42364 14.2361C9.55257 14.1072 9.625 13.9323 9.625 13.75V9.625C9.625 9.44267 9.55257 9.2678 9.42364 9.13887C9.2947 9.00994 9.11984 8.9375 8.9375 8.9375C8.75516 8.9375 8.5803 9.00994 8.45136 9.13887C8.32243 9.2678 8.25 9.44267 8.25 9.625V13.75Z" fill="#333333"/>
        </svg>
        {/* <div style={{width: '15px', height: '15px'}}>
          <svg width="6" height="22" viewBox="0 0 6 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.32145e-05 21.2003V20.5538C0.0142862 20.5015 0.0380579 20.4539 0.0475666 20.4016C0.256758 19.0419 1.38829 17.9674 2.71473 17.8771C4.19808 17.7725 5.45323 18.6187 5.8621 19.9975C5.9144 20.1782 5.95243 20.3683 5.99998 20.5538V21.2003C5.98571 21.2431 5.96194 21.2811 5.95719 21.3287C5.75275 22.5838 4.84943 23.5395 3.6133 23.8105C3.51821 23.8295 3.42312 23.858 3.32804 23.8818H2.68145C2.63866 23.8675 2.59587 23.8437 2.55308 23.839C1.31695 23.6393 0.375616 22.7597 0.0903322 21.5379C0.0618061 21.419 0.0285493 21.3097 2.32145e-05 21.2003ZM6 2.92472L5.99998 3.57135C5.98571 3.62365 5.96194 3.67119 5.95719 3.72349C5.74324 5.09274 4.60695 6.16247 3.26623 6.24805C1.78763 6.34313 0.53724 5.48735 0.133121 4.10384C0.0808232 3.92791 0.0427891 3.74726 0 3.57133V2.92474C0.014263 2.88195 0.0380347 2.84392 0.0475434 2.80113C0.275752 1.565 0.993656 0.756761 2.19175 0.37166C2.34864 0.319362 2.51504 0.290836 2.67669 0.248047H3.32328C3.36607 0.26231 3.40886 0.286082 3.45165 0.290836C4.69253 0.495273 5.62914 1.37007 5.9144 2.59194C5.94295 2.70604 5.97147 2.81539 6 2.92472ZM5.99998 11.7393V12.3859C5.98571 12.4382 5.96194 12.4857 5.95243 12.538C5.73849 13.9025 4.55941 15.0008 3.2282 15.0578C1.73058 15.1244 0.461171 14.221 0.104595 12.828C0.0665606 12.6806 0.0332804 12.5333 0 12.3859V11.7393C0.014263 11.687 0.0380347 11.6394 0.0475434 11.5871C0.256734 10.2226 1.44056 9.12437 2.77178 9.06259C4.2694 8.99128 5.53881 9.89935 5.89538 11.2924C5.93342 11.4445 5.9667 11.5919 5.99998 11.7393Z" fill="#333333"/>
          </svg>
        </div> */}
      </div>
      <div className="bottom">
        <h3>{bank.name}</h3>
        <h4>{bank.accountNumber}</h4>
        <h4>{bank.accountName}</h4>
      </div>
    </div>
  )
}
